import { useCallback } from "react";

import { section } from "../components/dynamicEditor/components/portalDynamicComponent";
import { Settings } from "../models";
import { ActionButton } from "../models/settings";
import { useLocationPortalApi, useQueryWrapper } from "./locationPortalApi";
import { LOCATION, DYNAMIC_COMPONENTS, SETTINGS } from "./queries";

export function useSettingsApi() {
	const { Get } = useLocationPortalApi();

	/**
	 * Get the configuration settings from the controller
	 * @param branchId
	 */
	const getSettings = useCallback(
		function (repId?: number, locationId?: number) {
			return Get<Settings>("GetSettings", { repId, locationId });
		},
		[Get],
	);

	const getActionButtons = useCallback(
		function (locationId: number) {
			return Get<ActionButton[]>("GetActionButtons", { locationId });
		},
		[Get],
	);

	const getDynamicComponents = useCallback(
		function () {
			return Get<section[]>("GetDynamicComponents").then(order);

			function order(sections: section[]) {
				if (!sections) return;
				for (const section of sections) {
					section.childSections?.sort((a, b) => a.ordinal - b.ordinal);
					section.components?.sort((a, b) => a.ordinal - b.ordinal);
					order(section.childSections);
				}
				return sections;
			}
		},
		[Get],
	);

	const useSettingsQuery = (repId?: number, locationId?: number) =>
		useQueryWrapper<Settings>([SETTINGS], [], () => getSettings(repId, locationId));

	const useDynamicComponentsQuery = () => useQueryWrapper<section[]>([DYNAMIC_COMPONENTS], [], getDynamicComponents);
	const useActionButtonsQuery = (locationId: number) =>
		useQueryWrapper<ActionButton[]>(LOCATION.ACTION_BUTTONS, [locationId], () => getActionButtons(locationId));
	return { useSettingsQuery, useDynamicComponentsQuery, useActionButtonsQuery };
}
